import createLucideIcon from '../createLucideIcon';

const Pilcrow = createLucideIcon('PilcrowIcon', [
  ['path', { d: 'M13 4v16', key: '8vvj80' }],
  ['path', { d: 'M17 4v16', key: '7dpous' }],
  ['path', { d: 'M19 4H9.5a4.5 4.5 0 0 0 0 9H13', key: 'sh4n9v' }],
]);

export default Pilcrow;
